module.exports = __webpack_public_path__ + "img/1440.d2e08ca6.jpg";